/**
 * 外部リンクを内部リンクに変換する
 * @param url 変換対象のURL
 * @returns 内部リンクに変換されたURL
 * @description https://reality.app/から始まるURLを、/から始まるURLに変換する。ただし、お知らせ等はlabからでもprodのデータを使ったりするので注意。
 */
export const changeInternalLink = (url: string): string => {
  // urlがhttp://またはhttps://から始まる絶対パスの場合
  if (url && url.match(/^https?:\/\//)) {
    // ドメイン以降のパス部分を抽出
    const path = url.replace(/^https?:\/\/[^/]+/, '')
    return path
  }
  return url
}
